import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-form-rental-reservation',
  templateUrl: './dialog-form-rental-reservation.component.html',
  styleUrls: ['./dialog-form-rental-reservation.component.scss'],
})
export class DialogFormRentalReservationComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<DialogFormRentalReservationComponent>,
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
